<template lang="pug">
.content-center
  .bets-wrap
    ul.d-flex.justify-content-around
      li.flex-grow-1
        a#runningList(href="javascript:void(0);" @click="goTab(0)" :class="{ 'active' : selected == 0 }") {{ $t("ui.running") }}
      li.flex-grow-1
        a(href="javascript:void(0);" @click="goTab(1)" :class="{ 'active' : selected == 1 }") {{ $t("ui.void") }}
  .page-panel
    .page-group#statement-0.statement-wrap
      .pagination-wrapper
        v-pagination(
          v-model="currentPage"
          :page-count="resultTotalPages"
          :classes="bootstrapPaginationClasses"
          :labels="paginationAnchorTexts"
          @input="changedPage($event)"
          v-if="resultTotalPages"
        )
      template(v-if="loading")
        .message.dark
          .empty.text-center.mt-2.pt-4
            .loading-wrap.mb-2
              .loading
                .block
                .block
                .block
          p.no-message.text-center.text-dark {{ $t("ui.loading") }}
      template(v-else)
        template(v-if="betList.length <= 0")
          .message.dark
            .empty.text-center.mt-3.pt-4
              i.fad.fa-exclamation-triangle
            p.no-message.text-center.text-dark {{ $t("message.no_information_available") }}
        template(v-else)
          template(v-for="match in betList")
            betSlip(:match="match" :status="status")
      .note-panel.text-left
        span {{ $t("ui.settled_remark") }}
      .pagination-wrapper
        v-pagination(
          v-model="currentPage"
          :page-count="resultTotalPages"
          :classes="bootstrapPaginationClasses"
          :labels="paginationAnchorTexts"
          @input="changedPage($event)"
          v-if="resultTotalPages"
        )
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import vPagination from "vue-plain-pagination";
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-betlist.js";
import service from "@/library/_xhr-statement";
import naming from "@/library/_name";
import betSlip from "@/components/mobile/bets/betSlip4d";

export default {
  components: {
    vPagination,
    betSlip
  },
  data() {
    return {
      loading: false,
      selected: 0,
      status: "accepted",
      betList: [],
      currDate: this.$dayjs().subtract("12", "hours").format("YYYY-MM-DD", config.timeZone),
      totalWinlose: 0,
      totalStake: 0,
      feedback: {
        success: false,
        status: errors.session.invalidSession
      },
      currentPage: 1,
      currentResultPage: 1,
      resultTotalRow: 0,
      resultTotalPages: 0,
      bootstrapPaginationClasses: {
        ul: "pagination justify-content-center",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
        buttonActive: "active",
        buttonDisable: "disable"
      },
      paginationAnchorTexts: {
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;"
      }
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  destroyed() {
    clearInterval(this.checkCounter);
  },
  mounted() {
    this.goTab(0);
  },
  methods: {
    goTab(e) {
      clearInterval(this.checkCounter);
      this.selected = e;
      this.currentPage = 1;
      this.currentResultPage = 1;
      switch (e) {
        case 0:
          this.status = "running";
          this.getBetAcceptFullList();
          break;
        case 1:
          this.status = "rejected";
          this.getBetRejectFullList();
          break;
      }
    },
    changePageList() {
      switch (this.selected) {
        case 0:
          this.status = "running";
          this.getBetAcceptFullList();
          break;
        case 1:
          this.status = "rejected";
          this.getBetRejectFullList();
          break;
      }
    },
    refreshList() {
      this.getBetAcceptFullList();
    },
    getBetAcceptFullList(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        this.betList = [];
        this.totalStake = 0;
        this.resultTotalRow = 0;
        this.resultTotalPages = 0;

        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          page_number: this.currentResultPage,
          page_size: this.getPageSize
        };
        xhr.get4dBetList(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data.length > 0) {
                this.betList = res.data;
                this.totalStake = res.data[0].total_betmember;
                this.resultTotalRow = this.betList.length > 0 ? this.betList[0].totalrows : 0;
                if (this.resultTotalRow % this.getPageSize != 0) this.resultTotalPages = Math.ceil(parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize));
                else this.resultTotalPages = parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize);
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    getBetRejectFullList(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        this.betList = [];
        this.resultTotalRow = 0;
        this.resultTotalPages = 0;

        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          page_number: this.currentResultPage,
          page_size: this.getPageSize
        };
        xhr.get4dBetListCancel(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data) {
                this.betList = res.data;
                this.resultTotalRow = this.betList.length > 0 ? this.betList[0].totalrows : 0;
                if (this.resultTotalRow % this.getPageSize != 0) this.resultTotalPages = Math.ceil(parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize));
                else this.resultTotalPages = parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize);
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    changedPage(pageNo) {
      this.currentResultPage = pageNo;
      this.changePageList();
    }
  }
};
</script>
